<template>
    <section>
        <b-card>
            <template #header>
                <div class="d-flex align-items-center justify-content-between">

                    <!-- SGA - Configuración -->
                    <h6 class="mb-0">
                        <strong>SGA - Configuración</strong>
                    </h6>

                    <!-- Versión disponibles -->
                    <div v-if="showActiveVersionFilter" class="d-flex align-items-center">
                        <b class="mr-2 text-info">Edición</b>
                        <SgaVersionFilter
                            version-label=""
                            :is-locked="false"
                            @version-changed="onHandleChangeVersion" />
                    </div>

                </div>
            </template>

            <el-select v-model="selectedValue" filterable class="mb-2 b-select-modules" @change="handleSelectChange">
                <el-option v-for="option in options" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>

            <b-tabs pills card vertical class="b-tabs-sp" nav-wrapper-class="w-40" no-key-nav lazy>
                <b-tab v-for="option in options" :key="option.value" :title="option.label"
                    @click="handleTabClick(option.value)" :active="activeTab === option.value">
                    <component :is="option.component" />
                </b-tab>
            </b-tabs>
        </b-card>

        <DuplicateVersions />
    </section>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import versions from './components/versions/Index.vue'
import typesOfDangers from './components/typesOfDangers/Index.vue'
import categories from './components/categories/Index.vue'
import languages from './components/languages/Index.vue'
import subcategories from './components/subCategories/Index.vue'
import pictograms from './components/pictograms/Index.vue'
import wordsOfCaution from './components/wordsOfCaution/Index.vue'
import indicationsOfDanger from './components/indicationsOfDanger/Index.vue'
import typesTipPrudence from './components/typesTipPrudence/Index.vue'
import tipsPrudence from './components/tipsPrudence/Index.vue'
import typesSubCategories from './components/typesSubCategories/Index.vue'
import rulesPictograms from './components/pictograms/rules/Index.vue'
import rulesTipsPrudence from './components/tipsPrudence/rules/Index.vue'
import rulesIndicationsOfDanger from './components/indicationsOfDanger/rules/Index.vue'
import potencialRisks from './components/potencialRisk/Index.vue';
import DuplicateVersions from './components/duplicateVersions/Home.vue';
import subNotDanger from './components/subNotDanger/Index.vue';
import SgaVersionFilter from '@/views/productos/classificationSystem/components/SgaVersionFilter.vue';

export default {
    name: 'Configurations',
    components: {
        versions,
        typesOfDangers,
        categories,
        languages,
        subcategories,
        pictograms,
        wordsOfCaution,
        indicationsOfDanger,
        typesTipPrudence,
        tipsPrudence,
        typesSubCategories,
        rulesPictograms,
        rulesTipsPrudence,
        rulesIndicationsOfDanger,
        potencialRisks,
        DuplicateVersions,
        subNotDanger,
        SgaVersionFilter
    },
    data() {
        return {
            activeTab: 'versions',
            selectedValue: 'versions',
            options: [
                { label: 'Ediciones', value: 'versions', component: 'versions' },
                { label: 'Lenguajes', value: 'languages', component: 'languages' },
                { label: 'Pictogramas', value: 'pictograms', component: 'pictograms' },
                { label: 'Tipos de peligro', value: 'typesOfDangers', component: 'typesOfDangers' },
                { label: 'Palabras de advertencia', value: 'wordsOfCaution', component: 'wordsOfCaution' },
                { label: 'Clase de peligro', value: 'categories', component: 'categories' },
                { label: 'Categorías', value: 'typesSubCategories', component: 'typesSubCategories' },
                { label: 'Tipos de consejos de prudencia', value: 'typesTipPrudence', component: 'typesTipPrudence' },
                { label: 'Consejos de prudencia (Frases P)', value: 'tipsPrudence', component: 'tipsPrudence' },
                { label: 'Indicaciones de peligro (Frases H)', value: 'indicationsOfDanger', component: 'indicationsOfDanger' },
                { label: 'Gestión de subcategorías', value: 'subcategories', component: 'subcategories' },
                { label: 'Gestión de sustancias no peligrosas', value: 'subNotDanger', component: 'subNotDanger' },
                { label: 'Reglas de pictogramas', value: 'rulesPictograms', component: 'rulesPictograms' },
                { label: 'Reglas de consejos de prudencia (Frases P)', value: 'rulesTipsPrudence', component: 'rulesTipsPrudence' },
                { label: 'Reglas de indicaciones de peligro (Frases H)', value: 'rulesIndicationsOfDanger', component: 'rulesIndicationsOfDanger' },
                { label: 'Peligros potenciales', value: 'potencialRisks', component: 'potencialRisks' },
            ]
        };
    },

    async created() {
        await this.getVersionsSga();
        await this.getActiveVersionsSga();
    },

    watch: {
        'mainVersionId': {
            handler(next, prev) {
                if (next != prev && next) {
                    this.setActiveGlobalVersion(next);
                }
            }
        }

    },

    computed: {

        ...mapState('sgaVersions', ['activeGlobalVersion', 'activeVersions', 'showActiveVersionFilter', 'mainVersionId']),
        ...mapState('sgaTypesOfDangers', ['filterTypesOfDangersSga']),

        ...mapState('potencialRisks', {
            filterPotencialRisk: 'filter'
        }),

    },

    methods: {
        ...mapActions('sgaVersions', ['getVersionsSga', 'getActiveVersionsSga']),
        ...mapActions('sgaTypesOfDangers', ['getTypeOfDangersSga']),
        ...mapActions('sgaCategories', ['getCategoriesSga']),
        ...mapActions('sgaLanguages', ['getLanguagesSga']),
        ...mapActions('sgaSubCategories', ['getSubCategoriesSga']),
        ...mapActions('sgaPictograms', ['getPictogramsSga']),
        ...mapActions('sgaWordsOfCaution', ['getWordsOfCautionSga']),
        ...mapActions('sgaIndicationsOfDanger', ['getIndicationsOfDangerSga']),
        ...mapActions('sgaTypesTipPrudence', ['getTypesTipPrudenceSga']),
        ...mapActions('sgaTipsPrudence', ['getTipsPrudenceSga']),
        ...mapActions('sgaTypesSubCategories', ['getTypesSubCategoriesSga']),
        ...mapActions('sgaRulesPictograms', ['getRulesPictogramsSga']),
        ...mapActions('sgaRulesTipsPrudence', ['getRulesTipsPrudenceSga']),
        ...mapActions('sgaRulesIndicationsOfDanger', ['getRulesIndicationsOfDangerSga']),
        ...mapActions('potencialRisks', ['getPaginatePotencialRisks']),
        ...mapActions('sgaSubNotDanger', ['getSubNotDangerSga']),

        ...mapMutations('sgaVersions', ['setActiveGlobalVersion', 'setShowActiveVersionFilter']),
        ...mapMutations('sgaTypesOfDangers', ['setEditionToFilterTypesOfDangersSga']),
        ...mapMutations('sgaCategories', ['setEditionToFilterCategoriesSga']),
        ...mapMutations('sgaSubCategories', ['setEditionToFilterSubCategoriesSga']),
        ...mapMutations('sgaRulesPictograms', ['setEditionToFilterRulesPictogramsSga']),

        handleSelectChange(value) {
            this.activeTab = value;
            this.callFunction(value);
        },

        handleTabClick(value) {
            this.activeTab = value;
            this.selectedValue = value;
            this.callFunction(value);
        },

        callFunction(value) {

            this.setShowActiveVersionFilter(false);

            switch (value) {
                case 'versions':
                    this.setShowActiveVersionFilter(false)
                    this.getVersionsSga();
                    break;
                case 'languages':
                    this.setShowActiveVersionFilter(false)
                    this.getLanguagesSga();
                    break;
                case 'pictograms':
                    this.setShowActiveVersionFilter(false)
                    this.getPictogramsSga();
                    break;
                case 'typesOfDangers':
                    this.setShowActiveVersionFilter(true)
                    this.setEditionToFilterTypesOfDangersSga(this.activeGlobalVersion)
                    this.getTypeOfDangersSga();
                    break;
                case 'wordsOfCaution':
                    this.setShowActiveVersionFilter(false)
                    this.getWordsOfCautionSga();
                    break;
                case 'categories':
                    this.setShowActiveVersionFilter(true)
                    this.setEditionToFilterCategoriesSga(this.activeGlobalVersion)
                    this.getCategoriesSga();
                    break;
                case 'subcategories':
                    this.setShowActiveVersionFilter(true)
                    this.setEditionToFilterSubCategoriesSga(this.activeGlobalVersion)
                    this.getSubCategoriesSga();
                    break;
                case 'indicationsOfDanger':
                    this.setShowActiveVersionFilter(false)
                    this.getIndicationsOfDangerSga();
                    break;
                case 'typesTipPrudence':
                    this.setShowActiveVersionFilter(false)
                    this.getTypesTipPrudenceSga();
                    break;
                case 'tipsPrudence':
                    this.setShowActiveVersionFilter(false)
                    this.getTipsPrudenceSga();
                    break;
                case 'typesSubCategories':
                    this.setShowActiveVersionFilter(false)
                    this.getTypesSubCategoriesSga();
                    break;
                case 'rulesPictograms':
                    this.setShowActiveVersionFilter(true)
                    this.setEditionToFilterRulesPictogramsSga(this.activeGlobalVersion)
                    this.getRulesPictogramsSga();
                    break;
                case 'rulesTipsPrudence':
                    this.setShowActiveVersionFilter(true)
                    this.getRulesTipsPrudenceSga();
                    break;
                case 'rulesIndicationsOfDanger':
                    this.setShowActiveVersionFilter(true)
                    this.getRulesIndicationsOfDangerSga();
                    break;
                case 'potencialRisks':
                    this.setShowActiveVersionFilter(false)
                    this.getPaginatePotencialRisks(this.filterPotencialRisk);
                    break;
                case 'subNotDanger':
                    this.setShowActiveVersionFilter(false)
                    break;
                default:
                    break;
            }
        },

        onHandleChangeVersion(edition) {
            this.setActiveGlobalVersion(edition)
        }

    },
}
</script>

<style>

.el-select-dropdown {
  max-width: 450px;
}

.el-select-dropdown .el-select-dropdown__item {
  /* Permite que el texto salte a la siguiente línea si no cabe */
  white-space: normal;
  /* Anula la altura fija del item para que pueda crecer verticalmente */
  height: auto;
  /* Mejora el espacio entre las líneas para que el texto sea más legible */
  line-height: 1.5;
  /* (Opcional) Un pequeño ajuste de padding para que se vea mejor verticalmente */
  padding-top: 8px;
  padding-bottom: 8px;
}
.b-tabs-sp .nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    color: #fff;
    background-color: #32696e;
}

.b-tabs-sp .nav-pills a {
    color: #32696e;
}

@media only screen and (max-width: 1450px) {
    .b-tabs-sp .nav-pills {
        display: none !important;
    }
}

@media only screen and (min-width: 1450px) {
    .b-select-modules {
        display: none !important;
    }
}

@media (min-width: 1450px) and (max-width: 1684px) {
    .tab-content {
        min-width: 800px;
        overflow-x: auto;
    }
}
</style>
